import React, { Fragment, useState } from 'react'
import BodyWrapper from '../../layouts/body/body'
import './style.css'
import StarIcon from '../../assets/images/star.png'
import { Para } from '../../components/typography/typography'
import AddNotesIcon from '../../assets/images/add_notes.svg'
import { useNavigate } from 'react-router-dom'
import { useFilePicker, FileContent } from 'use-file-picker'
import { uploadPractiseFile } from '../../services/backend'
import { PrimaryButton } from '../../components/buttons/buttons'
import { useDispatch, useSelector } from 'react-redux'
import { actionTypes } from '../../features/practise'
import { userSelectors } from '../../features/user'
import useSpeechToAudio from '../../components/audio-player/audioPlayer'


export const JDUpload: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const name = useSelector(userSelectors.getUserName)
  const [isLoading, setLoader] = useState(false);

  const speechText = `Please verify the Job Role`
  const { playSound } = useSpeechToAudio(speechText);

  const speechText2 = `We are evaluating the Role that you are applying for.`
  const secondSpeech = useSpeechToAudio(speechText2);

  const [openJDFileSelector, jdDocInfo] = useFilePicker({
    multiple: true,
    readAs: 'ArrayBuffer',
    accept: ['.pdf'],
    limitFilesConfig: { max: 1 },
    // minFileSize: 1, // in megabytes
    maxFileSize: 10,
    readFilesContent: true,
  })

  const ifFilePicked = (filesContent: FileContent[]) => {
    if (filesContent.length == 0) {
      return false
    } else {
      return true
    }
  }

  let documentUploading = false;
  const isButtonDisabled = !documentUploading && !ifFilePicked(jdDocInfo.filesContent)

  const navigateToNextPage = () => {
    setTimeout(() => {
      console.log('Navigating to Select Role Page!')
      navigate('/select-role')
    }, 500)
    setTimeout(()=>{
      playSound();
    },1000)
  }

  const getFileName = (docInfo: any) => {
    let filesContent = docInfo.filesContent
    if (filesContent.length == 0) {
      return ''
    } else {
      return filesContent[0].name
    }
  }

  const onDocumentUpload = () => {
    setLoader(true);
    setTimeout(()=>{
      secondSpeech.playSound();
    },100)
    documentUploading = true;
    uploadPractiseFile("JD", jdDocInfo.plainFiles[0]).then((fileInfo)=>{
      if(fileInfo) {
        dispatch({
          type: actionTypes.SET_PRACTISE_USER_JD_ID,
          jdId: fileInfo.data.data._id,
        })
        dispatch({
          type: actionTypes.SET_PRACTISE_USER_JD_METADATA,
          jdMetadata: fileInfo.data.data,
        })
        navigateToNextPage()
        documentUploading = false
        setLoader(false);
      }
    })
    .catch( err => {
      console.log(err)
      setLoader(false);
    })
  }

  return (
    <Fragment>
      <BodyWrapper isBackEnabled>
        <div className="d-flex justify-content-between flex-column text-center h-100 text-center">
        <div>
        <img src={StarIcon} className="mb-5 w-25 mx-auto" />
          <div>
            <Para textColor="var(--white)">
              {name}
            </Para>
            <Para textColor="var(--white)" className="mb-5">
              Please upload the Job Description
            </Para>
            <div
              className="doc-upload-cta"
              onClick={() => openJDFileSelector()}
            >
              {!ifFilePicked(jdDocInfo.filesContent) ? (
                <div>
                  <img src={AddNotesIcon} />
                  <Para textColor="var(--white)">Upload JD</Para>
                </div>
              ) : (
                <Para textColor="var(--white)">
                  {getFileName(jdDocInfo)}
                </Para>
              )}
            </div>
          </div>
        </div>
         
          <div className="d-grid mt-5">
            <PrimaryButton isDisabled={isButtonDisabled} handleBtnClick={onDocumentUpload} isLoading={isLoading}>
              Upload
            </PrimaryButton>
          </div>
        </div>
      </BodyWrapper>
    </Fragment>
  )
}
